import { createAction, props } from '@ngrx/store';
import { SplashMessage } from '../../lib/splash-message';

export const add = createAction('[SplashMessage] Add', props<{ message: SplashMessage }>());

export const hide = createAction('[SplashMessage] Hide', props<{ id: string }>());
